import {h} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";


export function CashoutContents({children}) {
	return <div class="cl-casht-contnt p-2">{children}</div>
}
export function CashoutFiltersRow({children}) {
	return <div class="cl-casht-flt-row p-2 flex justify-start">{children}</div>
}
export function CashoutFilter({children}) {
	return <div class="cl-casht-flt fn-type-filters flex bg-slate-800 p-1">{children}</div>
}
export function CashoutFilterButton({children, onClick, active}) {
	if (active)
		return <div class="cl-casht-flt-btn py-1 text-center w-20 uppercase text-sm bg-slate-700" onClick={onClick}>{children}</div>
	return <div class="cl-casht-flt-btn py-1 text-center w-20 uppercase text-sm hover:bg-slate-700" onClick={onClick}>{children}</div>
}


export function MobileCashoutFiltersRow({ children }) {
	return <div class="cl-casht-flt-row p-2 flex justify-center items-center">{children}</div>
}
export function MobileCashoutFilterButton({ children, onClick, active }) {
	if (active)
		return <div class="cl-casht-flt-btn first:rounded-l last:rounded-r bg-amber-600 text-slate-50 py-1 text-center w-20 uppercase text-sm" onClick={onClick}>{children}</div>
	return <div class="cl-casht-flt-btn first:rounded-l last:rounded-r bg-slate-600 text-slate-50 py-1 text-center w-20 uppercase text-sm hover:bg-slate-700" onClick={onClick}>{children}</div>
}

export function CashoutTicketsContainer({children}) {
	return <div class="cl-casht-tkt-cont p-2 grid gap-4 grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">{children}</div>
}
export function CashoutTicketCell({children}) {
	return <div class="cl-casht-tkt-cell w-full md:w-1/4">{children}</div>
}

export function PageLayout() {
	return <CashoutContents>
		<CashoutFiltersRow>
			<CashoutFilter>
				<CashoutFilterButton active={true}>Closed</CashoutFilterButton>
				<CashoutFilterButton>Live</CashoutFilterButton>
				<CashoutFilterButton>Pending</CashoutFilterButton>
			</CashoutFilter>
		</CashoutFiltersRow>
		<CashoutTicketsContainer>
			<SampleTicket />
			<SampleTicket />
			<SampleTicket />
			<SampleTicket />
		</CashoutTicketsContainer>
	</CashoutContents>
}


export function Ticket({children}) {
	return <div class="cl-tkt rounded-lg overflow-hidden">{children}</div>
}

export function TicketHeader({children, onClick}) {
	return <div class="cl-tkt-head fn-mybet-t-header flex justify-between px-2 py-2 text-sm items-center bg-amber-400 text-slate-950" onClick={onClick}>{children}</div>
}

export function TicketType({children}) {
	return <div class="cl-tkt-type font-bold">{children}</div>
}
export function TicketPrintBtn({children, onClick}) {
	return <div lcass="cl-tkt-print-btn " onClick={onClick}>{children}</div>
}

export function TicketSelections({children}) {
	return <div class="cl-tkt-selections fn-mybet-t-body bg-white text-black px-2">{children}</div>
}
export function TicketSelection({children}) {
	return <div class="cl-tkt-selection border-b last:border-b-0">{children}</div>
}

export function TicketEvent({children}) {
	return <div class="cl-tkt-evt truncate">{children}</div>
}
export function TicketTournament({children}) {
	return <div class="cl-tkt-tournament text-xs">{children}</div>
}
export function TicketDate({children}) {
	return <div class="cl-tkt-date text-xs">{children}</div>
}
export function TicketOutcome({children}) {
	return <div class="cl-tkt-outcome flex items-center text-sm">{children}</div>
}
export function TicketOutcomeDescription({children}) {
	return <div class="cl-tkt-out-desc w-full truncate min-w-0">{children}</div>
}
export function TicketOutcomeLiveOdd({children}) {
	return <div class="cl-tkt-out-liveodd px-2">{children}</div>
}
export function TicketOutcomeOdd({children}) {
	return <div class="cl-tkt-out-odd pr-1">{children}</div>
}
export function TicketOutcomeStatusIcon({children}) {
	return <div class="cl-tkt-out-statusicon w-6">{children}</div>
}

export function TicketPriceInfo({children}) {
	return <div class="cl-tkt-priceinfo fn-mybet-t-status flex justify-between items-center border-t bg-white text-black px-2 py-1">{children}</div>
}

export function TicketPrice({children}) {
	return <div class="cl-tkt-price fn-stake text-ceter text-sm flex justify-between">{children}</div>
}
export function TicketMaxWin({children}) {
	return <div class="cl-tkt-max-win selections fn-totwin text-ceter text-sm flex justify-between">{children}</div>
}
export function TicketStatus({children}) {
	return <div class="cl-tkt-status fn-status flex border px-2 py-1">{children}</div>
}

export function TicketPriceLabel({children}) {
	return <div class="cl-tkt-price-lbl">{children}</div>
}
export function TicketPriceValue({children}) {
	return <div class="cl-tkt-price-val text-sm font-bold">{children}</div>
}
export function TicketPriceAccentedValue({children}) {
	return <div class="cl-tkt-price-acc-value ">{children}</div>
}

export function CashoutEmptyStatus() {
	return <div class="cl-casht-status p-2 text-white"><span><Trans>Non ci sono scommesse in corso</Trans></span></div>;
}

function SampleTicket() {
	return <Ticket>
		<TicketHeader>
			<TicketType>Live</TicketType>
			<TicketPrintBtn>P</TicketPrintBtn>
		</TicketHeader>
		<TicketSelections>
			<TicketSelection>
				<TicketEvent>Event name - Away team</TicketEvent>
				<TicketTournament>tournament</TicketTournament>
				<TicketDate>date</TicketDate>
				<TicketOutcome>
					<TicketOutcomeDescription>Match Result - W1</TicketOutcomeDescription>
					<TicketOutcomeOdd>1.45</TicketOutcomeOdd>
					<TicketOutcomeStatusIcon>W</TicketOutcomeStatusIcon>
				</TicketOutcome>
			</TicketSelection>
		</TicketSelections>
		<TicketPriceInfo>
			<TicketPrice>
				<TicketPriceLabel>Stake:</TicketPriceLabel>
				<TicketPriceValue>1111</TicketPriceValue>
			</TicketPrice>
			<TicketMaxWin>
				<TicketPriceLabel>Total Win</TicketPriceLabel>
				<TicketPriceValue>1111</TicketPriceValue>
			</TicketMaxWin>
			<TicketStatus>
				<TicketPriceLabel>Pending</TicketPriceLabel>
				<TicketPriceAccentedValue></TicketPriceAccentedValue>
				<TicketOutcomeStatusIcon>W</TicketOutcomeStatusIcon>
			</TicketStatus>
		</TicketPriceInfo>
	</Ticket>
}